import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaGoogle } from 'react-icons/fa';
import { MdArrowBack } from 'react-icons/md';
import { useAdminAuth } from '../../context/AdminAuthContext';
import './Admin.css';

const AdminLogin = () => {
    const { login, isAdmin } = useAdminAuth();
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (isAdmin) {
        navigate('/admin', { replace: true });
    }

    const handleGoogleLogin = async () => {
        setError('');
        setLoading(true);
        const result = await login();
        setLoading(false);
        if (result.success) {
            navigate('/admin', { replace: true });
        } else {
            setError(result.error);
        }
    };

    return (
        <div className="admin-page admin-login-page">
            <div className="admin-card admin-login-card">
                <button type="button" className="admin-back-btn" onClick={() => navigate('/')}>
                    <MdArrowBack size={20} /> Back to Home
                </button>

                <h1>Seller Login</h1>
                <p className="admin-subtitle">Sign in with your Google account to manage products</p>

                {error && <div className="admin-error">{error}</div>}

                <button
                    type="button"
                    className="admin-btn admin-btn-primary admin-google-btn"
                    onClick={handleGoogleLogin}
                    disabled={loading}
                >
                    <FaGoogle size={16} /> {loading ? 'Signing in...' : 'Sign in with Google'}
                </button>
            </div>
        </div>
    );
};

export default AdminLogin;
